import React from 'react'
import ElectricityBill from '../../Components/Products/electricity-bills'

const ElectricityMain = () => {
  return (
	 <ElectricityBill />
  )
}

export default ElectricityMain